/**
 * Detecta o "tier" de performance do dispositivo baseado em heurísticas
 * do navegador. Setamos `data-perf-tier` no <html> e o CSS suaviza efeitos
 * caros (Liquid Glass, blur pesado, animações complexas) nos devices mais
 * fracos.
 *
 * Critérios:
 *  - `navigator.deviceMemory` ≤ 2 → low (Android barato, ~2GB RAM)
 *  - `navigator.hardwareConcurrency` ≤ 4 → low (CPUs antigas)
 *  - Senão → high
 *
 * iPhone reporta sempre memory=8 e cores=6 → high. Galaxy A04 / similares
 * tipicamente reportam memory=2 / cores=4 → low.
 *
 * Rodado uma vez no boot do app.
 */

type PerfTier = 'low' | 'high';

interface NavigatorWithMemory extends Navigator {
  deviceMemory?: number;
}

export function detectPerfTier(): PerfTier {
  if (typeof navigator === 'undefined') return 'high';
  const nav = navigator as NavigatorWithMemory;
  const mem = typeof nav.deviceMemory === 'number' ? nav.deviceMemory : 8;
  const cores = typeof navigator.hardwareConcurrency === 'number'
    ? navigator.hardwareConcurrency
    : 8;
  if (mem <= 2 || cores <= 4) return 'low';
  return 'high';
}

/** Aplica `data-perf-tier` no <html>. Idempotente. */
export function applyPerfTier(): PerfTier {
  const tier = detectPerfTier();
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.setAttribute('data-perf-tier', tier);
  }
  return tier;
}
